export default "__VITE_ASSET__Bcqc7M$C__"